interface AnnotationTypeCatalogEntry {
  type_code: string;
  display_name: string;
}

export function getAnnotationTypeDisplayName(
  typeCode: string,
  catalog: AnnotationTypeCatalogEntry[],
): string {
  const entry = catalog.find(
    (item) => item.type_code.toLowerCase() === typeCode.toLowerCase(),
  );
  return entry?.display_name || typeCode;
}

/** Drop redundant "Annotation @ 1:23" text when Time column already shows onset. */
export function formatAnnotationListLabel(
  label: string,
  typeCode: string,
  catalog: AnnotationTypeCatalogEntry[],
): string {
  const trimmed = label.trim();
  if (/^annotation\s*@\s*[\d.:]+s?$/i.test(trimmed)) {
    return getAnnotationTypeDisplayName(typeCode, catalog);
  }
  if (!trimmed) {
    return getAnnotationTypeDisplayName(typeCode, catalog);
  }
  return trimmed;
}
